<template>
    <div class="app-subheader" :class="subheaderClasses" v-if="title">
        <layout-contained>
            <div class="flex h-12 flex-row items-stretch space-x-3">
                <button-subheader
                    :buttonText="hasParent ? parent.title : title"
                    :buttonRoute="hasParent ? parent.route : $route"
                    :dark="dark"
                ></button-subheader>
                <div class="flex-column flex items-center" :class="dark ? 'text-white' : 'text-black'">
                    <icon-chevron-right :size="4"></icon-chevron-right>
                </div>
                <button-subheader
                    v-if="hasParent"
                    :buttonText="title"
                    :buttonRoute="$route"
                    :dark="dark"
                ></button-subheader>
                <div class="grow"></div>
                <slot></slot>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppSubheader',
    props: {
        title: {
            required: false,
            type: String,
            default: null,
        },
        parent: {
            required: false,
            type: Object,
            default: null,
        },
        dark: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasParent() {
            return this.parent && this.parent.title && this.parent.route;
        },
        subheaderClasses() {
            const cls = {};
            cls['bg-zinc-100'] = !this.dark;
            cls['bg-zinc-800'] = !!this.dark;
            return cls;
        },
    },
};
</script>
